import React, { Component } from 'react';
import { Link } from 'react-router';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getUser, downloadSectionsList, logoutUser } from '../../../actions/participant-action';
import './style.css';


class HeaderBottom extends Component {

  onDropdownClick() {
    this.refs.dropdown.hide();
  }

  componentWillMount() {
    this.props.downloadSectionsList();
    this.props.getUser();
  }

  onLogoutClick() {
    this.onDropdownClick();
    this.props.logoutUser();
  }

  render() {
    const classes = classNames(
      'header__bottom',
      {'header__bottom_fixed': this.props.fixed}
    );
    let linkSchedule;
    if (this.props.sections.length > 0) {
      const firstSection = '/schedule/' + this.props.sections[0].id;
      const secondSection = '/schedule/' + this.props.sections[1].id;
      if (decodeURI(window.location.pathname) === firstSection || decodeURI(window.location.pathname) === secondSection) {
        linkSchedule = '/' + decodeURI(window.location.pathname.split('/')[2]);
      } else {
        linkSchedule = '/' + this.props.sections[0].id;
      }
    }
    const headerMenu = [
      <Link to='/' className='header__logo' key='main' >
        <div className='header__menu-item header__menu-item_logo' onClick={this.onDropdownClick.bind(this)} >
          главная
        </div>
      </Link>,
      <Link to={'/schedule' + linkSchedule} activeClassName='header__menu-item_active' key='schedule' >
        <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
          программа
        </div>
      </Link>,
      <Link to='/speakers' key='speakers' activeClassName='header__menu-item_active' >
        <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
          докладчики
        </div>
      </Link>,
      <Link to='/participants' key='participants' activeClassName='header__menu-item_active' >
        <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
          участники
        </div>
      </Link>,
      <Link to='/reviews' key='reviews' activeClassName='header__menu-item_active' >
        <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
          все отзывы
        </div>
      </Link>
      // <Link to={'/schedule' + linkSchedule} activeClassName='header__menu-item_active' key='schedule' >
      //   <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
      //     программа
      //   </div>
      // </Link>,
      // <Link to='/speakers' key='speakers' activeClassName='header__menu-item_active' >
      //   <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
      //     докладчики
      //   </div>
      // </Link>,
      // <Link to='/participants' key='participants' activeClassName='header__menu-item_active' >
      //   <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
      //     участники
      //   </div>
      // </Link>,
      // <Link to='/about' key='about' activeClassName='header__menu-item_active' >
      //   <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
      //     о нас пишут
      //   </div>
      // </Link>
    ];

    let registrationStatus = null;
    if (this.props.registrationClosed) {
      registrationStatus = (
        <div className='header__menu-item header__menu-item_registration-closed'>
          регистрация закрыта
        </div>
      );
    }

    let userMenu = null;
    if (this.props.withServer && this.props.user.userShortView) {
      userMenu = (
        <div className='header__user-menu'>
          <Link key='user' to='/profile' className='header__auth-item' activeClassName='header__menu-item_active' >
            <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)} >
              {this.props.user.userShortView.firstName}
            </div>
          </Link>
          <div className='header__auth-item'>
            <div key='logout' onClick={this.onLogoutClick.bind(this)} className='header__menu-item'>
              выход
            </div>
          </div>

          {registrationStatus}
        </div>
      );
    } else if (this.props.withServer) {
      let signUp = null;
      let signIn = null;
      if (!this.props.registrationClosed) {
        signUp = (
          <Link activeClassName='header__menu-item_active' key='register' to='/register' className='header__auth-item' >
            <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)}>
              регистрация
            </div>
          </Link>
        );
        signIn = (
          <Link key='auth' to='/auth' className='header__auth-item' activeClassName='header__menu-item_active' >
            <div className='header__menu-item' onClick={this.onDropdownClick.bind(this)}>
              вход
            </div>
          </Link>
        );
      }
      userMenu = (
        <div className='header__user-menu'>
          {signIn}
          {signUp}

          {registrationStatus}
        </div>
      )
    } else {
      userMenu = (
        <div className='header__user-menu'>
          {registrationStatus}
        </div>
      )
    }

    return(
      <div className={classes}>
        <Dropdown ref='dropdown'
                  className='header__menu_mobile'>
          <DropdownTrigger>
            <div className='dropdown__icon'>меню</div>
          </DropdownTrigger>
          <DropdownContent>
            {headerMenu}
            {this.props.withServer ? <div className='dropdown__divider' /> : null}
            {userMenu}
          </DropdownContent>
        </Dropdown>
        <div className='header__container-bottom'>
          <div className='header__desktop'>
            {headerMenu}
            {userMenu}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.participant.participantView,
  sections: state.participant.allSections,
  withServer: state.participant.withServer,
  registrationClosed: state.participant.registrationClosed
});

const mapDispatchToProps = (dispatch) => ({
  downloadSectionsList: bindActionCreators(downloadSectionsList, dispatch),
  getUser: bindActionCreators(getUser, dispatch),
  logoutUser: bindActionCreators(logoutUser, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(HeaderBottom);



// WEBPACK FOOTER //
// ./src/layout-page/blocks/header-bottom/HeaderBottom.js